import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { api } from "../../api/client";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { AuthLayout } from "../../components/layout/AuthLayout";
import { authTokenFromHash } from "../../lib/authTokenFromHash";
import { apiError } from "../../lib/apiError";

export function VerifyEmailPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const token = authTokenFromHash();
      if (!token) {
        if (!cancelled) {
          setError("Brak tokenu weryfikacyjnego. Użyj linku z wiadomości e-mail.");
          setBusy(false);
        }
        return;
      }
      const result = await api.POST("/api/auth/verify-email", {
        body: { token },
      });
      if (cancelled) {
        return;
      }
      if (result.error) {
        setError(apiError(result.error, "Nieprawidłowy lub wygasły link weryfikacyjny."));
        setBusy(false);
        return;
      }
      navigate("/login?verified=1", { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <AuthLayout title="Potwierdzenie e-mail">
      {busy ? (
        <p className="auth__subtitle" role="status" data-testid="verify-email-pending">
          Trwa weryfikacja adresu e-mail…
        </p>
      ) : null}
      {error ? (
        <>
          <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
          <p className="auth__footer">
            <Link to="/login">Wróć do logowania</Link>
          </p>
        </>
      ) : null}
    </AuthLayout>
  );
}
